import { defaultApiState } from "../api.state";

export default {
  apiState: {
    getAdminPermissions: defaultApiState,
    getAdminRoles: defaultApiState,
    getAdminRole: defaultApiState,
    deleteAdminRole: defaultApiState,
    addAdminRole: defaultApiState,
    updateAdminRole: defaultApiState,
  },
  permissions: [],
  adminRoles: [],
  adminRole: undefined,
};
